import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { TextField } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useTheme } from "@mui/material/styles";
import { useScriptMode } from "../../contexts/ScriptModeContext";
import { useAuth } from "../../contexts/AuthContext";
import { useUpdateProfileMutation } from "../../api/userApi";
import { useToast } from "../../components/ui/Toast";
import { AccountHeader, FixedFooter, RowGroup } from "./components/AccountSoft";
import { greenButtonSx } from "./actionStyles";
import "./darkSurface.css";

/**
 * Profil Bilgileri (mobildeki ayrı sayfa): ad ve soyad; kaydet altta sabit,
 * yeşil. Kayıttan sonra hesap sayfasına dönülür.
 */
export default function AccountProfilePage() {
  const { t } = useScriptMode();
  const { user, setUser } = useAuth();
  const toast = useToast();
  const navigate = useNavigate();
  const mode = useTheme().palette.mode;

  const schema = yup.object({
    name: yup.string().required(t("validation_required")),
    surname: yup.string().required(t("validation_required")),
  });
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isDirty },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: { name: user?.name || "", surname: user?.surname || "" },
  });

  useEffect(() => {
    reset({ name: user?.name || "", surname: user?.surname || "" });
  }, [user, reset]);

  const [updateProfile, { isLoading }] = useUpdateProfileMutation();

  const onSubmit = async (values) => {
    const result = await updateProfile(values);
    if (result.error) {
      toast.error(result.error.message || t("profile_update_error"));
      return;
    }
    if (result.data?.data?.user) setUser(result.data.data.user);
    toast.success(t("profile_update_success"));
    navigate("/uygulama/hesap");
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="tk-dark w-full max-w-3xl mx-auto flex flex-col gap-4"
    >
      <AccountHeader title={t("Profil Bilgileri")} backTo="/uygulama/hesap" />
      <RowGroup>
        <div className="p-4 flex flex-col gap-4">
          <TextField
            label={t("name")}
            {...register("name")}
            error={Boolean(errors.name)}
            helperText={errors.name?.message}
          />
          <TextField
            label={t("surname")}
            {...register("surname")}
            error={Boolean(errors.surname)}
            helperText={errors.surname?.message}
          />
        </div>
      </RowGroup>
      <FixedFooter>
        <LoadingButton
          type="submit"
          variant="contained"
          size="large"
          fullWidth
          loading={isLoading}
          disabled={!isDirty}
          sx={{ ...greenButtonSx(mode), borderRadius: 999 }}
        >
          {t("Profili Güncelle")}
        </LoadingButton>
      </FixedFooter>
    </form>
  );
}
